var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.514,
    height: 40,
    viewBox: "0 0 52.514 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132474",
    "data-name": "Group 132474",
    transform: "translate(-482.25 -461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128777",
    "data-name": "Group 128777",
    transform: "translate(489.82 461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M23.722,42.35a5.049,5.049,0,0,1-1.611-.239,30.329,30.329,0,0,1-5.989-2.94,36.943,36.943,0,0,1-6.839-5.466,29.467,29.467,0,0,1-5.665-8A24.378,24.378,0,0,1,1.25,15.215,12.859,12.859,0,0,1,14.108,2.35a12.665,12.665,0,0,1,5.84,1.406A12.922,12.922,0,0,1,23.722,6.7,12.8,12.8,0,0,1,33.336,2.35,12.859,12.859,0,0,1,46.194,15.215,24.378,24.378,0,0,1,43.825,25.71a29.467,29.467,0,0,1-5.665,8,36.942,36.942,0,0,1-6.839,5.466,30.328,30.328,0,0,1-5.989,2.94A5.049,5.049,0,0,1,23.722,42.35ZM14.108,3.981A11.24,11.24,0,0,0,2.888,15.215c0,7.961,4.115,13.83,7.568,17.351a33.971,33.971,0,0,0,12.188,8l.008,0a3.953,3.953,0,0,0,2.14,0l.008,0a33.971,33.971,0,0,0,12.188-8c3.452-3.521,7.568-9.39,7.568-17.351A11.2,11.2,0,0,0,24.379,8.48a.821.821,0,0,1-1.315,0A11.08,11.08,0,0,0,14.108,3.981Z",
    transform: "translate(-1.25 -2.35)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(482.25 473.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91217",
    "data-name": "Path 91217",
    d: "M24.972,16.636c-.419,0-1.2-.2-1.739-1.54l-2.4-6.062A3.749,3.749,0,0,0,17.661,6.88l-12.62.042a.819.819,0,1,1-.005-1.638l12.622-.042a5.386,5.386,0,0,1,4.7,3.187l2.4,6.061a2,2,0,0,0,.217.416,2.015,2.015,0,0,0,.218-.419L30.006,2.268C30.474,1.077,31.224.861,31.63.838a1.9,1.9,0,0,1,1.776,1.242l2.188,4.145a3.841,3.841,0,0,0,3,1.814h8.541a.819.819,0,1,1,0,1.638H38.594a5.444,5.444,0,0,1-4.449-2.689L31.958,2.846a1.257,1.257,0,0,0-.234-.331,1.259,1.259,0,0,0-.194.353L26.712,15.091C26.175,16.436,25.391,16.636,24.972,16.636Z",
    transform: "translate(-4.22 -0.836)",
    fill: "#09143a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/Life.cae8496f5340c079b95d93990e62341e.svg";
export { ForwardRef as ReactComponent };